export default __webpack_public_path__ + "static/media/30.7d77b944.png";